
export default {
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            },
        },
        color: {
            type: String,
            default: '',
        },
        textColor: {
            type: String,
            default: '',
        },
        bold: Boolean,
        middle: Boolean,
    },
}
